import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './template.pug';

export function getExperimentBudgetAlert({
  i18n,
  jsdata,
  appState,
  legacyRouter,
}) {
  return class ExperimentBudgetAlert extends DeterministicView {
    initialize({
      experimentId,
      campaignId,
    }) {
      this.i18n = i18n;
      this.appState = appState;

      if (experimentId) {
        // current campaign is an experiment
        this.setState({
          isLoading: true,
        });
        jsdata.Experiment.find(experimentId, {
          bypassCache: false,
          cacheResponse: true,
        }).then((response) => {
          this.setState({
            isLoading: false,
            baseCampaign: {
              Id: response.BaseCampaignId,
              Name: response.BaseCampaignName,
            },
          });
        });
      } else if (campaignId) {
        // current campaign has active or scheduled experiments
        this.setState({
          campaignId,
        });
      }
    }

    get template() {
      return template;
    }

    get events() {
      return {
        'click .base-campaign-settings-link': () => legacyRouter.navigateToRoute('campaign_edit', { campaign_id: this.getState().baseCampaign.Id }),
        'click .all-experiments-link': () => legacyRouter.navigateToRoute('campaign_experiments', { campaign_id: this.getState().campaignId }),
      };
    }
  };
}
